export default __webpack_public_path__ + "static/media/online-skola-bg.9c545a11.png";